module.exports = __webpack_public_path__ + "static/mapleleaffoods-logo-c3739cb4ba17e679cb2884b4eb37c6fb.png";